import { readOnly } from "models/restutil";

export class GlobalAnalysisDto {
  public static ApiUrl = 'api/global-analyses';

  Id: number;
  AnalysisNo: string
  Name: string;
  Version: string;
  Author: string;
  Date?: Date;
  NetType: string;
  NetDepth: string
  NetSolidity: string;
  SinkerBottomRingKg?: number;
  SinkerCenterWeightKg?: number
  Note: string;
  Created?: Date;
  Updated?: Date;
  Deleted?: Date;
  @readOnly()
  IsDeleted: boolean;
}
